import A from 'utils/metrics/analytic'

// Переход на Medpulse
const A_cc_medpulseClick = () => {
  A.setEvent('medpulse_click')
}

enum originClinCase {
  CLINICAL_LIST = 'clinical_list',
  CLIN_REC = 'clinical_recomendation',
  LANDING = 'landing',
  NOORIGIN = 'noorigin',
}

const A_cc_openClinCase = (origin: originClinCase, id: number) => {
  if (origin === originClinCase.NOORIGIN) {
    A.setEvent('clinic_open', { id: String(id) })
  } else {
    A.setEvent('clinic_open', { origin, id: String(id) })
  }
}

export { A_cc_medpulseClick, A_cc_openClinCase, originClinCase }
